export function assertAbsurd(argument: never): never {
  throw new Error(`Unexpected argument: ${argument}`);
}
